'use client';
// ^ this file needs the "use client" pragma

import { ApolloClient, ApolloNextAppProvider } from '@apollo/client-integration-nextjs';
import { initializeGraphqlAppClient } from '../../api/graphql/initializeGraphqlAppClient';

// have a function to create a client for you
function makeClient(): ApolloClient<any> {
  return initializeGraphqlAppClient({ mode: 'client' });
}

// you need to create a component to wrap your app in
export function ApolloWrapper({ children }: React.PropsWithChildren) {
  return <ApolloNextAppProvider makeClient={makeClient}>{children}</ApolloNextAppProvider>;
}
